import { IonButton, IonCol, IonContent, IonGrid, IonIcon, IonModal, IonRow } from '@ionic/react';
import { closeCircleSharp, sparklesSharp } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import DAService from '../../services/DAService.service';
import TextHelper from '../../utils/TextHelper';
import ListGrid from '../ListGrid/ListGrid';

// eslint-disable-next-line
export default function OptionModal(props: { option: any, setOption: any }) {
  const { option, setOption } = props;
  const [showModal, setShowModal] = useState(false);
  const [addResources, setAddResources] = useState([]);

  useEffect(() => {
    if (option) {
      setShowModal(true);
      setAddResources(option?.inlineGuidance?.filter((l: any) => TextHelper.isURL(l?.urlString)));
    }
  }, [option]);

  return (
    <IonModal
      isOpen={showModal}
      onDidDismiss={() => {
        setOption(null);
        setShowModal(false);
      }}
      style={{ paddingTop: '100px', borderRadius: '8px' }}
    >
      <IonContent>
        <IonGrid style={{ width: '100%', padding: '16px' }}>
          <IonRow>
            <IonCol
              size="11"
              style={{
                fontSize: '21px',
                lineHeight: '23px',
                letterSpacing: '0.2px',
                fontFamily: 'HelveticaRegular',
                fontWeight: '600',
                marginTop: '16px',
                padding: '0px',
              }}
            >
              {TextHelper.stripHTML(option?.name)}
            </IonCol>
            <IonCol size="1" style={{ display: 'flex', justifyContent: 'end' }}>
              <IonIcon
                style={{ fontSize: '24px', cursor: 'pointer' }}
                src={closeCircleSharp}
                onClick={(() => {
                  setShowModal(false);
                })}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol
              size="4"
              style={{
                padding: '0px',
              }}
            >
              <IonButton
                fill="clear"
                style={{
                  background: '#F3F3F3',
                  color: '#6C6C6C',
                  fontSize: '16px',
                  letterSpacing: '-0.15px',
                  fontFamily: 'HelveticaRegular',
                  textTransform: 'none',
                  borderRadius: '10.5px',
                }}
              >
                <IonIcon
                  slot="start"
                  src={sparklesSharp}
                  style={{ color: 'yellow' }}
                />
                Default
              </IonButton>
            </IonCol>
            <IonCol
              size="5"
              style={{
                padding: '0px',
              }}
            >
              <IonButton
                fill="clear"
                // className="option-modal-btn"
                style={{
                  background: '#F3F3F3',
                  color: '#6C6C6C',
                  fontSize: '16px',
                  letterSpacing: '-0.15px',
                  fontFamily: 'HelveticaRegular',
                  textTransform: 'none',
                  borderRadius: '10.5px',
                }}
              >

                {`${DAService.getOptionPhasePath(option?.itemId)?.name} Phase`}
              </IonButton>
            </IonCol>
            <IonCol size="3" />
          </IonRow>
          <IonRow style={{
            marginTop: '8px',
          }}
          >
            <div className="option-modal-section-label">
              Overview
            </div>
          </IonRow>
          <div>
            {/* eslint-disable-next-line  */}
            <div dangerouslySetInnerHTML={{ __html: option?.description || '' }} />

            <div className="option-modal-section-label">
              Key Points / Trade-offs
            </div>
            {/* eslint-disable-next-line  */}
            <div dangerouslySetInnerHTML={{ __html: option?.tradeoffs || '' }} />
          </div>
          <IonRow />
          {addResources?.length
            ? (
              <>
                <IonRow className="additional-resources">
                  Additional Resources
                </IonRow>
                {addResources?.map((url: any, index: number) => (
                  <a
                    href={url.urlString}
                    target="_blank"
                    rel="noreferrer"
                    key={`url-${url.itemId}-${Math.random()}`}
                    style={{ textDecoration: 'none' }}
                  >
                    <ListGrid
                      item={url}
                      arrayLength={addResources?.length}
                      index={index}
                      itemType="option-link"
                    />
                  </a>
                ))}
              </>
            ) : null}
        </IonGrid>
      </IonContent>
    </IonModal>
  );
}
